/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
// import sensors from 'sa-sdk-javascript';
import updateLocation2 from './location2';
import { isWebZip } from './webzip';
import sensors from './lib/sensorsdata.min';
import {
  utility
} from './utility';
import ISONLINE from './domainJudge';

// 神策 domain 列表
const domainList = [
  'sensor.aaalive.com',
  'sensor.livemeet.tv',
  'sensor.lmpluss.com',
  'sensor.emolm.com',
  'sensor.highlives.net',
  'sensor.sparkher.cc',
  'sensor.coinsgames.net',
  'sensor.joyu.live'
];
const defaultDomain = 'livemesensor.liveme.com';

const getSensorDomain = () => {
  const { host } = window.location2;
  const hostArr = host.split('.');
  let domain = '';
  if (hostArr.length === 3) {
    domain = host.replace(/\w{1,}./, 'sensor.');
  } else {
    domain = `sensor.${host}`;
  }
  if (domainList.includes(domain)) {
    return domain;
  }
  return defaultDomain;
};


/**
 * @desc 同步加载神策代码
 */
// pc 新增 来源： 通过 url 参数获取来源
export const getQueryFrom = () => {
  // 获取来源 参数 事例
  // ?utm_source=google%2B&utm_medium=video&utm_campaign=1
  const source = utility.getQueryString('utm_source');
  const medium = utility.getQueryString('utm_medium');
  const campaign = utility.getQueryString('utm_campaign');
  return source || medium || campaign ? `${source}_${medium}_${campaign}` : '';
};
// const loc = window.location2
// default 测试 production 线上
const project = ISONLINE ? 'production' : 'default';
const showLog = project == 'default';
window.sensors = sensors;
sensors.init({
  // sdk_url: 'https://static.sensorsdata.cn/sdk/1.11.9/sensorsdata.min.js',
  // heatmap_url: 'https://static.sensorsdata.cn/sdk/1.11.9/heatmap.min.js',
  name: 'sensors',
  web_url: `https://${getSensorDomain()}/?project=${project}`,
  server_url: `https://${getSensorDomain()}/sa?project=${project}`,
  heatmap: {},
  show_log: showLog
});
// initSensor({
//   sdk_url: 'https://static.sensorsdata.cn/sdk/1.11.9/sensorsdata.min.js',
//   heatmap_url: 'https://static.sensorsdata.cn/sdk/1.11.9/heatmap.min.js',
//   name: 'sensors',
//   web_url: 'https://livemesensor.liveme.com/?project=' + project,
//   server_url: 'https://livemesensor.liveme.com/sa?project=' + project,
//   heatmap: {},
//   show_log: showLog
// })

// 神策自动跟踪 最好添加 页面加载后调用一次即可
window.sensors.quick('autoTrack');

/**
 * @desc 获取公共参数   ==============================
 */
const publicPram = {
  xaid: '', // uuid    string
  lmweb_islogin: '', // 登录方式 lmweb_islogin=96：H5登录 lmweb_islogin=97：APP登录 lmweb_islogin=98：pc登录  byte
  lmweb_platform: 0, // 设备类型  lmweb_platform=1：安卓APP lmweb_platform=2：IOS-APP lmweb_platform=3：PC lmweb_platform=4：安卓H5 lmweb_platform=5：IOS-H5
  lmweb_language: '', // 用户语言 string
  lmweb_tmzone: '', // 所在时区 string
  lmweb_channel: '', // 渠道标识 string
  lmweb_display: '', // 分辨率 string
  lmweb_mnc: 0, // 网络id  short
  lmweb_brv: '', // 浏览器版本 string
  lmweb_ver: '', // 客户端版本号  string
  lmweb_visib: 1, // 页面可见性区分预缓存  Number 1可见，0不可见
  lmweb_userinfo: '', // 用户信息
  lmweb_url: window.location2.href, // 当前页面地址
  lmweb_host: window.location2.host, // 当前页面host
  lmweb_path: window.location2.pathname, // 当前页面path
  lmweb_pageverid: '' // 当前页面版本标识
};
// 如果 是 zip包 在上报时候拼接zip版本号
if (isWebZip) {
  publicPram.lmweb_url = `${window.location2.href}&zipVer=${window.KEWLWebZip.version}`;
}
const ua = navigator.userAgent;
function initPublicParams() {
  const lua = ua.toLowerCase();
  const countryCode = window.navigator.userLanguage || window.navigator.language;
  const display = `${window.screen.width}*${window.screen.height}`;
  let version;
  let network;
  let uuid;
  let lmwebPlatform;
  let lmwebVisib;

  const match = /(chrome)[ /]([\w.]+)/i.exec(lua)
    || /(AppleWebKit)[ /]([\w.]+)/i.exec(lua)
    || /ms(ie)\s([\w.]+)/i.exec(lua)
    || /(safari)[ /]([\w.]+)/i.exec(lua)
    || /(firefox)[ /]([\w.]+)/i.exec(lua)
    || [];
  if (match && match[1]) {
    [, , version] = match;
    console.info(version);
  }

  // 网络
  let networkType = navigator.connection && (navigator.connection.effectiveType || navigator.connection.type)
    ? navigator.connection.effectiveType || navigator.connection.type
    : '0';

  networkType = networkType.toLowerCase();
  if (networkType.indexOf('wifi') > -1) {
    network = 1;
  } else if (networkType.indexOf('2g') > -1) {
    network = 2;
  } else if (networkType.indexOf('3g') > -1) {
    network = 3;
  } else if (networkType.indexOf('4g') > -1) {
    network = 4;
  } else {
    network = 0;
  }
  // 平台
  if (window.KEWLApp && window.KEWLApp.isKEWLApp && utility.isAndroid()) {
    lmwebPlatform = 1;
  } else if (window.KEWLApp && window.KEWLApp.isKEWLApp && utility.isIos()) {
    lmwebPlatform = 2;
  } else if (window.KEWLApp && !window.KEWLApp.isKEWLApp && utility.isAndroid()) {
    lmwebPlatform = 4;
  } else if (window.KEWLApp && !window.KEWLApp.isKEWLApp && utility.isIos()) {
    lmwebPlatform = 5;
  } else {
    lmwebPlatform = 3;
  }
  // lmwebChannel
  const lmwebChannel = utility.getQueryString('f')
    ? utility.getQueryString('f')
    : utility.getQueryString('from')
      ? utility.getQueryString('from')
      : utility.getQueryString('channel')
        ? utility.getQueryString('channel')
        : utility.getQueryString('source')
          ? utility.getQueryString('source')
          : getQueryFrom()
            ? getQueryFrom()
            : '0';
  // uuid;
  console.info(utility.getCookie('uuid'));
  uuid = utility.getCookie('uuid');
  if (!uuid) {
    uuid = utility.createUUID();
    utility.setCookie('uuid', uuid, {
      expires: 365
    });
  }
  // 为了区分预缓存的pv数，通过参数lmweb_visib的可见性去区分，不可见表示预缓存，可见为正常访问
  if (document.visibilityState === 'hidden' || document.hidden) {
    lmwebVisib = 0;
  } else {
    lmwebVisib = 1;
  }

  publicPram.lmweb_brv = version;
  publicPram.lmweb_display = display;
  publicPram.lmweb_mnc = network;
  publicPram.lmweb_language = countryCode;
  publicPram.lmweb_channel = lmwebChannel;
  publicPram.lmweb_platform = lmwebPlatform;
  publicPram.lmweb_tmzone = Math.abs(new Date().getTimezoneOffset() / 60); // 时区
  publicPram.lmweb_visib = lmwebVisib;
  // todo 实时获取的数据：publicPram.userid   publicPram.liveid  publicPram.logintype publicPram.logtime
  // 如果是APP内使用  获取userinfo
  if (window.KEWLApp && window.KEWLApp.isKEWLApp) {
    publicPram.lmweb_ver = window.KEWLApp.getVerName();
    window.KEWLApp.getUserInfo((data) => {
      const userInfo = typeof data === 'string' && data !== 'null' && data !== ''
        ? JSON.parse(data)
        : data;
      if (
        userInfo instanceof Object
        && userInfo.userId
        && userInfo.token
        && userInfo.deviceId
      ) {
        // publicPram.userid = userInfo.userId;
        // publicPram.distinct_id = userInfo.userId;
        window.sensors.login(userInfo.userId);
        publicPram.xaid = userInfo.deviceId;
        publicPram.lmweb_islogin = 97; // app 内登录
        publicPram.lmweb_userinfo = window.Base64.encode(JSON.stringify(userInfo));
      }
    });
  } else {
    const userInfo = window.localStorage ? (window.localStorage.getItem('userInfo')
      ? JSON.parse(window.Base64.fromBase64(window.localStorage.getItem('userInfo')))
      : '') : '';
    // 用户选择登录的时候纪录登录方式 logintype
    // var loginType = localStorage.getItem('regType') || 0;
    // 如果用户是登录状态
    if (userInfo instanceof Object && userInfo.user && userInfo.user.uid) {
      window.sensors.login(userInfo.user.uid);
      publicPram.xaid = uuid;
      if (utility.isMobile()) {
        publicPram.lmweb_islogin = 96; // H5 登录
      } else if (!utility.isMobile()) {
        publicPram.lmweb_islogin = 98; // PC 登录
      }
      publicPram.lmweb_userinfo = window.Base64.encode(JSON.stringify(userInfo));
    } else {
      // 如果用户没有登录  只保留xaid属性
      publicPram.xaid = uuid;
      // window.sensors.login(uuid)
    }
  }
  // 依据注入到页面头的标识获取 <meta name="sensors:pageverid" content="webpack202102261520"> 或者 <script id="sensors:pageverid" content="webpack202102261520"></script>
  const pageveridA = document.getElementById('sensors:pageverid') ? document.getElementById('sensors:pageverid').getAttribute('content') || '' : '';
  const pageveridB = document.getElementsByName('sensors:pageverid') && document.getElementsByName('sensors:pageverid').length ? document.getElementsByName('sensors:pageverid')[0].getAttribute('content') || '' : '';
  const lmwebPageverid = pageveridA || pageveridB;
  publicPram.lmweb_pageverid = lmwebPageverid;
}

/**
 * @desc kewl 通用神策
 * 各业务需要使用神策埋点时，默认使用通用的神策公共参数，业务表参数和业务字段参数通过register方法注册
 * 上报过程只需要关注当前上报的字段即可，其他字段不上报默认使用初始化值;
 * @demo KEWLSensor.register('testTable', {key1:'',key2:0,key3: false}); KEWLSensor.track({key2: 1});
 */
const KEWLSensor = {
  version: '0.0.3',
  _tableName: [],
  _businessPram: [], //  [{tablename: {params}},{tablename: {params}}]
  businessPram: [], //  [{tablename: {params}},{tablename: {params}}]
  _tableName2: '',
  _businessPram2: '', //  [{tablename: {params}},{tablename: {params}}]
  businessPram2: '', //  [{tablename: {params}},{tablename: {params}}]
  register(tableName, initPramas) {
    if (window.sensors) {
      initPublicParams(); // 公共参数初始化

      window.sensors.registerPage(publicPram); // 神策注册公共参数
      this._tableName.push(tableName);

      this.businessPram.push({
        tableName,
        params: initPramas
      });
      // this.businessPram去重
      const obj = {};
      this.businessPram = this.businessPram.reduce((item, next) => {
        obj[next.tableName] ? '' : obj[next.tableName] = true && item.push(next);
        return item;
      }, []);

      this._businessPram.push({
        tableName,
        params: utility.copy(initPramas)
      });

      // 兼容历史情况 在track的时候不传递tablename情况 默认使用注册的besinesparam
      this._tableName2 = tableName;
      this.businessPram2 = initPramas;
      this._businessPram2 = utility.copy(initPramas);
    }
  },
  track(tableName, params) {
    // 兼容不传递表名的情况
    if (arguments.length == 1 && typeof tableName === 'object') {
      for (const action in this.businessPram2) {
        if (Object.prototype.hasOwnProperty.call(tableName, action) && Object.prototype.hasOwnProperty.call(this.businessPram2, action)) {
          this.businessPram2[action] = tableName[action];
        } else {
          this.businessPram2[action] = this._businessPram2[action];
        }
      }
      window.sensors.track(this._tableName2, JSON.parse(JSON.stringify(this.businessPram2)));
      return;
    }
    if (window.sensors && this._tableName.indexOf(tableName) > -1 && typeof params === 'object') {
      for (let i = 0; i < this.businessPram.length; i += 1) {
        if (this.businessPram[i].tableName == tableName) {
          // eslint-disable-next-line no-restricted-syntax
          for (const business in this.businessPram[i].params) {
            if (Object.prototype.hasOwnProperty.call(params, business) && Object.prototype.hasOwnProperty.call(this.businessPram[i].params, business)) {
              this.businessPram[i].params[business] = params[business];
            } else {
              this.businessPram[i].params[business] = this._businessPram[i].params[business];
            }
          }
          console.info(this.businessPram[i].tableName);
          console.info(this.businessPram[i].params);
          window.sensors.track(this.businessPram[i].tableName, JSON.parse(JSON.stringify(this.businessPram[i].params)));
        }
      }
    }
  }
};

window.KEWLSensor = KEWLSensor;
export default KEWLSensor;
// // 使用示例
// KEWLSensors.register('lm_cashout', {
//   key: 'value',
//   key1: 'value1'
// });

// KEWLSensors.track({
//   key: 'valuenew'
// });
